class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormSubmit(event) {
    const val = (this.input.value || '').trim();
    if (val && window.BingeUniverseResolver && typeof window.BingeUniverseResolver.match === 'function') {
      const handle = window.BingeUniverseResolver.match(val);
      if (handle) {
        event.preventDefault();
        window.location.href = `/collections/${handle}`;
      }
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

(function checkSearchUrlUniverse() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('q');
    if (q) {
      const tryRedirect = () => {
        if (window.BingeUniverseResolver && typeof window.BingeUniverseResolver.match === 'function') {
          const handle = window.BingeUniverseResolver.match(q);
          if (handle) {
            window.location.replace(`/collections/${handle}`);
            return true;
          }
        }
        return false;
      };
      if (!tryRedirect()) {
        window.addEventListener('DOMContentLoaded', tryRedirect);
        window.addEventListener('load', tryRedirect);
      }
    }
  } catch (e) {}
})();
